module.exports = __webpack_public_path__ + "static/media/boxImage.823330a8.png";